import { GET_AIRPORT_SUCESS, GET_AIRPORT_FAIL, GET_AIRPORT, MISSING_TOKEN, GET_REGION, GET_REGION_FAIL, GET_REGION_SUCESS } from '../actions';
import { getLang } from '../api';

const INITIAL_STATE = {
    airports: [],
    airportCodes: [],
    airportCodeName: [],
    airportNameCode: [],
    airportCodePoint: [],
    markers: [],
    regions: [],
    loadingMap: false,
    error: '',
    invalidAccess: false
};

export default function( state = INITIAL_STATE, action ) {
    switch(action.type) {
        case GET_AIRPORT:
            return { ...state, loadingMap: true };
        case GET_AIRPORT_SUCESS:
            return setAirport(state, action.payload.data);
        case GET_AIRPORT_FAIL:
            return { ...state, loadingMap: false, error: action.payload.error };
        case GET_REGION:
            return { ...state, loadingMap: true };
        case GET_REGION_FAIL:
            return { ...state, loadingMap: false, regions: [], error: action.payload.error };
        case GET_REGION_SUCESS:
            return setRegion(state, action.payload.data);
        case MISSING_TOKEN:
            return { ...state,  invalidAccess: true, loadingMap: false}; 
        default:
            return state;
    }
}

const setRegion = (state, data) => {
    if (data === null) {
        return { ...state, regions: [], loadingMap: false, error: '' };
    }
    const lang = getLang();
    data.sort((a, b) => a.name[lang].localeCompare(b.name[lang], lang, { sensitivity: 'base' }));
    const vietnamIndex = data.findIndex(region => region && region.name && region.name.en && region.name.en.toUpperCase() === 'VIETNAM');
    if (vietnamIndex > 0) {
        const [vietnamRegion] = data.splice(vietnamIndex, 1);
        data.unshift(vietnamRegion);
    }

    return { ...state, loadingMap: false, regions: data };
}

const setAirport = (state, data) => {
    if (data === null) {
        return { ...state, airports: [], markers: [], loadingMap: false, error: '' };
    }

    const lang = getLang();
    data.sort((a, b) => a.name[lang].localeCompare(b.name[lang], lang, { sensitivity: 'base' }));
    const airportCodeName = [];
    const airportNameCode = [];
    const airportCodePoint = [];
    const airports = [];
    const airportCodes = [];
    for (const i in data) {
        if (isNaN(data[i].lat) || isNaN(data[i].lng)) {
            continue;
        }
        airportCodeName[data[i].code] = data[i].name;
        airportNameCode[data[i].name[lang]] = data[i].code;
        airports.push(data[i].name[lang]);
        airportCodes.push(data[i].code);
        airportCodePoint[data[i].code] = { lat: data[i].lat, lng: data[i].lng };
    }



    return { ...state, airports, airportCodes, airportCodeName, airportNameCode, airportCodePoint, markers: data, loadingMap: false, error: ''};
}
